export default __webpack_public_path__ + "static/media/SantoshTamboli.f5d27959.png";